<template>
  <v-btn
      depressed
      :color="color"
      :dark="isDark"
      :outlined="isOutline"
      :class="style"
      :disabled="disabled"
      @click="$emit('click')">
    <slot/>
  </v-btn>
</template>

<script>
export default {
    name: 'botaoAcao',
    props: {
        active: {
            type: Boolean,
            default: true
        },
        dark: {
            type: Boolean,
            default: false
        },
        hideBorder: {
            type: Boolean,
            default: false
        },
        cssClass: {
            type: String,
            default: ''
        },
        disabled: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'primary'
        }
    },
    computed: {
        isDark() {
            return this.dark && !this.active
        },
        isOutline() {
            return !this.active
        },
        style() {
            let styleObj = {
                'call-to-action': true,
                'hide-border': this.hideBorder
            }
            if (this.cssClass) {
                const classes = this.cssClass.split(' ')
                classes.forEach(clazz => (styleObj[clazz] = true))
            }
            return styleObj
        }
    }
}
</script>

<style scoped lang="stylus">
.call-to-action
  font-size 14px
  margin 0
  text-transform none
  position relative
  height unset
  padding 5px 15px
  box-shadow none
  font-weight bold

  i
    margin-right 5px
    font-size 18px

  &.hide-border
    border 0 !important

</style>